// @flow
export { default } from './CategoryNavItem';



// WEBPACK FOOTER //
// ./src/components/categories/CategoryNavItem/index.js